module.exports = {
      id: "login-usage",
      viewBox: "0 0 14.742 20.333",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#login",
      toString: function () {
        return this.url;
      }
    }